import { render, staticRenderFns } from "./ExportMessage.vue?vue&type=template&id=494c21b5&"
import script from "./ExportMessage.vue?vue&type=script&lang=js&"
export * from "./ExportMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExportMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports